import React from 'react';

interface ButtonEditorialProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  textColor?: string;
  shadowText?: boolean;
  shadowColor?: string;
  iconColor?: string;
  textHover?: string;
  hoverBgColor?: string;
  iconHover?: string;
  variant?: string;
  isActive?: boolean;
  onClick?: () => void;
  iconPosition?: 'left' | 'right';
  pl?: string;
  pr?: string;
  pt?: string;
  pb?: string;
  roundedFull?: boolean;
}

const ButtonEditorial = React.memo(({
  icon,
  children,
  className = '',
  textColor = 'var(--BlackBrand)',
  shadowText = false,
  shadowColor = '',
  iconColor = 'var(--BlackBrand)',
  textHover,
  hoverBgColor = 'rgba(0, 0, 0, 0.05)',
  iconHover,
  variant,
  isActive,
  onClick,
  iconPosition = 'left',
  pl = '0.5em',
  pr = '0.5em',
  pt = '0.5em',
  pb = '0.5em',
  roundedFull = false,
  ...rest
}: ButtonEditorialProps) => {
  const buttonStyle = {
    '--text-color': textColor,
    '--icon-color': iconColor,
    '--hover-bg-color': hoverBgColor,
    '--text-hover': textHover || textColor,
    '--icon-hover': iconHover || iconColor,
    ...rest.style,
  } as React.CSSProperties;

  const innerDivStyle = {
    paddingLeft: pl,
    paddingRight: pr,
    paddingTop: pt,
    paddingBottom: pb,
  };

  return (
    <button
      className={`w-full h-full group cursor-pointer outline-none ${className}`}
      onClick={onClick}
      style={buttonStyle}
      {...rest}
    >
      <div
        className={`flex ${roundedFull ? 'rounded-full' : 'rounded-[0.625em]'} gap-[0.5em] items-center group-hover:bg-[var(--hover-bg-color)] group-active:scale-[0.97] justify-center transition-all duration-400 ease-[cubic-bezier(.52,.97,.62,.99)]`}
        style={innerDivStyle}
      >
        {icon && iconPosition === 'left' && (
          <div className="text-[var(--icon-color)] group-hover:text-[var(--icon-hover)] transition-colors duration-300">
            {icon}
          </div>
        )}
        {children && (
          <span
            className={`text-[var(--text-color)] group-hover:text-[var(--text-hover)] transition-colors duration-300
              ${shadowText ? `drop-shadow-[0_0_8px_${shadowColor}]` : ''}`}
          >
            {children}
          </span>
        )}
        {icon && iconPosition === 'right' && (
          <div className="text-[var(--icon-color)] group-hover:text-[var(--icon-hover)] transition-colors duration-300">
            {icon}
          </div>
        )}
      </div>
    </button>
  );
});

ButtonEditorial.displayName = 'ButtonEditorial';

export default ButtonEditorial; 